import styled from 'styled-components'
import { Noto_body2_r14, Noto_desc_b10 } from 'src/styles/fonts/NotoSansKrFonts'

const TermsModal = ({ children }: { children: string }) => {
  const contents = children?.replaceAll('<p>&nbsp;</p>', '')

  return (
    <S.TermsModalContainer>
      <S.TermsModalContents dangerouslySetInnerHTML={{ __html: contents }} />
    </S.TermsModalContainer>
  )
}
export default TermsModal

const S = {
  TermsModalContainer: styled.div`
    display: flex;
    flex-direction: column;
    gap: 5px;
    width: 100%;
    padding: 10px 6px 6px 6px;
    max-height: 200px;
    height: 100%;
    border-radius: 12px;
    background: var(--black-2);
    margin-bottom: 26px;
  `,
  TermsModalContents: styled.div`
    white-space: pre-wrap;
    overflow-x: hidden;
    overflow-y: scroll;
    ${Noto_body2_r14};
    text-align: left;
    letter-spacing: 0.5px;
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 5px;
    ol {
      gap: 10px;
      display: flex;
      flex-direction: column;
      margin: 3px 0;
      padding-left: 25px;
    }
    ol,
    li {
      list-style: auto;
    }
    strong {
      font-weight: 700;
    }
    h2 {
      margin: 3px 0;
    }
    tr {
      border: 1px solid var(--black-10);
      padding: 0;
    }

    td {
      border: 1px solid var(--black-10);
      padding: 2.5px 3px;
    }

    th {
      color: var(--black-60);
      ${Noto_desc_b10};
      text-align: left;
      padding: 10px 12px;
      background-color: var(--black-6);
    }

    table {
      font-size: 12px;
      border-radius: 4px;
      border: 1px solid var(--black-10);
      background: #fff;
      margin: 10px 0;
    }
  `,
}
